import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import styles from './style.css';
import type { INavButton } from './models';

export const NavButton: FC<INavButton> = ({
    Button,
    children,
    className,
    dataTestId,
    onClick,
    visible,
}) => {
    return (
        <Button
            // TODO: Здесь через className от ArrowRigth или ArrowLeft уже прилетает external-класс
            // но линтер это не понимает и заставляет еще раз добавить external
            // в итоге у нас в снепшотах у button 2 external-класса, поэтому заглушил пока здесь линтер
            // http://gitlab.k8s.alfa.link/alfabank/nodejs/akit/-/merge_requests/4748#note_153259
            // eslint-disable-next-line external-classname/specificity
            data-test-id={dataTestId}
            innerClassName={cn(
                styles.button,
                styles.navButton,
                {
                    [styles.visible]: visible,
                },
                className
            )}
            onClick={onClick}
            view="ghost"
        >
            {children}
        </Button>
    );
};
